/**
 * @generated SignedSource<<01755034b1d375c688e6d46c0038efef>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpSharedTracking_item$data = {
  readonly browseUrl?: string | null;
  readonly categoryCode?: string | null;
  readonly contemporaryTrackingString?: string;
  readonly firstPhotoWebPath?: string | null;
  readonly pdpTrackingVpvParams?: any | null;
  readonly seller?: {
    readonly dealerSince: string | null;
    readonly isRewardsTier2: boolean | null;
    readonly sellerOrderQuantity: number | null;
    readonly sellerTiers: {
      readonly isGoldTier: boolean | null;
      readonly isPlatinumTier: boolean | null;
    } | null;
  } | null;
  readonly seoAbTestV2List?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"trackSeoTests_abTestConfigV2UserVariant">;
  } | null> | null;
  readonly viewInRoomPhotos?: ReadonlyArray<{
    readonly __typename: "viewInRoomPhotos";
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceTracking_item">;
  readonly " $fragmentType": "usePdpSharedTracking_item";
};
export type usePdpSharedTracking_item$key = {
  readonly " $data"?: usePdpSharedTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpSharedTracking_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "RootArgument",
  "name": "userCountryCode"
},
v1 = {
  "kind": "RootArgument",
  "name": "userId"
},
v2 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    (v0/*:: as any*/),
    (v1/*:: as any*/)
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpSharedTracking_item",
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": "small"
            }
          ],
          "kind": "ScalarField",
          "name": "firstPhotoWebPath",
          "storageKey": "firstPhotoWebPath(size:\"small\")"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contemporaryTrackingString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v2/*:: as any*/),
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "pdpTrackingVpvParams",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "viewInRoomPhotos",
          "kind": "LinkedField",
          "name": "viewInRoomPhotos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "alias": "isRewardsTier2",
              "args": [
                {
                  "kind": "Literal",
                  "name": "listName",
                  "value": "SELLER_REWARDS_2"
                }
              ],
              "kind": "ScalarField",
              "name": "isAnchorListMember",
              "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dealerSince",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sellerOrderQuantity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SellerTiers",
              "kind": "LinkedField",
              "name": "sellerTiers",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isGoldTier",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPlatinumTier",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "pricingGuidanceTracking_item",
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "buyerId",
                  "variableName": "userId"
                },
                {
                  "kind": "Literal",
                  "name": "isBuyerEstimateEnabled",
                  "value": true
                },
                {
                  "kind": "Variable",
                  "name": "isTrade",
                  "variableName": "isTrade"
                },
                {
                  "kind": "Variable",
                  "name": "priceBookName",
                  "variableName": "priceBookName"
                },
                (v2/*:: as any*/)
              ],
              "concreteType": "PricingGuidance",
              "kind": "LinkedField",
              "name": "pricingGuidance",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "price",
                  "plural": false,
                  "selections": (v3/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "minAmount",
                  "plural": false,
                  "selections": (v3/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "maxAmount",
                  "plural": false,
                  "selections": (v3/*:: as any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": [
            {
              "kind": "RootArgument",
              "name": "isTrade"
            },
            {
              "kind": "RootArgument",
              "name": "priceBookName"
            },
            (v0/*:: as any*/),
            (v1/*:: as any*/)
          ]
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AbTestConfigV2UserVariant",
          "kind": "LinkedField",
          "name": "seoAbTestV2List",
          "plural": true,
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "trackSeoTests_abTestConfigV2UserVariant",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "variant",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AbTestConfigV2",
                  "kind": "LinkedField",
                  "name": "config",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "testName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "8ed59a21699dac5d6bb440d99ebe0454";

export default node;
